import React, { useEffect, useState } from 'react';

// The post-login intro: the TapTap wordmark, then "Tap", "Breathe", "Relax"
// appear one by one (each fading in and gently pulsing), then the words fade
// out over a solid black backdrop and we hand off to the orb screen.
const WORDS = ['Tap', 'Breathe', 'Relax'];

const IntroAnimation = ({ onDone }) => {
  const [shown, setShown] = useState(0); // how many of the three words are visible
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timers = [];
    timers.push(setTimeout(() => setShown(1), 1200));
    timers.push(setTimeout(() => setShown(2), 2800));
    timers.push(setTimeout(() => setShown(3), 4400));
    timers.push(setTimeout(() => setFading(true), 7200)); // hold, then fade the words out
    timers.push(setTimeout(() => onDone(), 8400));
    return () => timers.forEach(clearTimeout);
  }, [onDone]);

  return (
    // The backdrop stays solid black throughout — we only fade the *content* out,
    // so the handoff to the orb screen never flashes a white webview background.
    <div className="min-h-screen bg-black flex flex-col items-center justify-center select-none">
      <div
        className={`flex flex-col items-center transition-opacity duration-1000 ${fading ? 'opacity-0' : 'opacity-100'}`}
      >
        <h1 className="intro-fade text-5xl font-extrabold tracking-tight bg-gradient-to-r from-blue-400 via-indigo-300 to-purple-400 bg-clip-text text-transparent mb-10">
          TapTap
        </h1>

        {/* The three words sit in a row and use the brand gradient. Each word's
            gradient, clip-to-text and pulse must all live on the SAME element as
            the text — a transformed child paints in its own layer, so a gradient
            clipped on an ancestor would never fill it (the word would vanish).
            The outer wrapper only handles the staggered fade-in. */}
        <div className="flex flex-row items-center justify-center gap-5">
          {WORDS.map((w, i) => (
            <span key={w} className={`inline-block ${shown > i ? 'intro-fade' : 'opacity-0'}`}>
              <span
                className={`inline-block text-2xl sm:text-3xl font-bold tracking-wide bg-gradient-to-r from-blue-400 via-indigo-300 to-purple-400 bg-clip-text text-transparent ${shown > i ? 'intro-pulse' : ''}`}
              >
                {w}
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IntroAnimation;
